var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-modal",
    {
      attrs: { options: _vm.modalOptions },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
        hide: function ($event) {
          return _vm.submit()
        },
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _vm._t("header", function () {
            return [
              _c("div", { staticClass: "margin-bottom" }, [
                _vm._v(" Select Final Agreement Rates "),
              ]),
              _c("div", { staticClass: "layout-row" }, [
                _c(
                  "div",
                  { staticClass: "material-icons", class: _vm.$style.infoIcon },
                  [_vm._v(" info ")]
                ),
                _c("div", [
                  _c("p", { class: _vm.$style.infoText }, [
                    _vm._v(
                      " Click on the rate you wish to appear on the final agreement. "
                    ),
                  ]),
                  _c("p", { class: _vm.$style.infoText }, [
                    _vm._v(" Rates appearing in "),
                    _c("span", { class: _vm.$style.infoGreen }, [
                      _vm._v("Green"),
                    ]),
                    _vm._v(" will be considered your final approved rates. "),
                  ]),
                ]),
              ]),
            ]
          }),
        ],
        2
      ),
      !_vm.questionnaire
        ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { class: _vm.$style.loading }, [_c("rb-loading")], 1),
          ])
        : _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c(
              "div",
              {
                class: _vm.isError
                  ? _vm.$style.tableContainerError
                  : _vm.$style.tableContainer,
              },
              [
                _c(
                  "table",
                  { staticClass: "final-agreement", class: _vm.$style.table },
                  [
                    _c(
                      "tr",
                      [
                        _c(
                          "th",
                          { staticClass: "season", attrs: { colspan: "2" } },
                          [_vm._v(" " + _vm._s(_vm.tableTitle) + " ")]
                        ),
                        _vm._l(_vm.rates, function (rate, rIndex) {
                          return _c(
                            "th",
                            {
                              key: "r." + rIndex,
                              staticClass: "rate",
                              attrs: { colspan: _vm.occupanciesLength },
                            },
                            [_vm._v(" " + _vm._s(rate) + " ")]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._l(_vm.seasons, function (season) {
                      return [
                        _c(
                          "tr",
                          { key: "s" + season.label, staticClass: "heading" },
                          [
                            _c("td", { staticClass: "season" }, [
                              _vm._v(" " + _vm._s(season.label) + " "),
                            ]),
                            _c("td", { staticClass: "room-type" }, [
                              _vm._v(" RT "),
                            ]),
                            _vm._l(_vm.rates, function (rate, rIndex) {
                              return _vm._l(
                                _vm.occupancies,
                                function (occupancy) {
                                  return _c(
                                    "td",
                                    {
                                      key:
                                        "s" +
                                        season.label +
                                        "r" +
                                        rIndex +
                                        "o" +
                                        occupancy.label,
                                      staticClass: "rate",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(occupancy.label) + " "
                                      ),
                                    ]
                                  )
                                }
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._l(_vm.roomTypes, function (roomType, rtIndex) {
                          return _c(
                            "tr",
                            { key: "s" + season.label + "rt" + rtIndex },
                            [
                              roomType === 1
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "season",
                                      attrs: { rowspan: _vm.roomTypesLength },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(season.period)),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _c("td", { staticClass: "room-type" }, [
                                _vm._v(" " + _vm._s(roomType) + " "),
                              ]),
                              _vm._l(_vm.rates, function (rate, rIndex) {
                                return _vm._l(
                                  _vm.occupancies,
                                  function (occupancy) {
                                    return _c(
                                      "td",
                                      {
                                        key:
                                          "s" +
                                          season.label +
                                          "r" +
                                          rIndex +
                                          "o" +
                                          occupancy.label,
                                      },
                                      [
                                        _c("rate-container", {
                                          staticClass: "rate",
                                          attrs: {
                                            rate: rate,
                                            occupancy: occupancy.id,
                                            season: season.id,
                                            "room-type": roomType,
                                            answers: _vm.answers,
                                            selected: _vm.acceptedRates,
                                            toggle: _vm.toggle,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                )
                              }),
                            ],
                            2
                          )
                        }),
                      ]
                    }),
                  ],
                  2
                ),
                _vm.currency
                  ? _c("div", { class: _vm.$style.currency }, [
                      _vm._v(" * All rates are in "),
                      _c("strong", [_vm._v(_vm._s(_vm.currency))]),
                    ])
                  : _vm._e(),
                _vm.isDynamicRateRequested
                  ? _c("dynamic-rate-container", {
                      attrs: {
                        toggle: _vm.toggle,
                        answers: _vm.answers,
                        selected: _vm.acceptedRates,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "errors-container" }, [
              _c(
                "div",
                { staticClass: "errors", class: { "rb-show": _vm.isError } },
                [_vm._v(" At least one rate must be selected! ")]
              ),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }